module.exports = __webpack_public_path__ + "static/the-june-motel-logo-add85084c34f68157473a47bc3f832c9.png";